import { forwardRef } from 'react'
import { useTranslation } from 'react-i18next'

export type ChatTextInputProps = {
  value: string
  onChange?: (value: string) => void
  onSubmit?: (event: React.KeyboardEvent<HTMLTextAreaElement>) => void
}

export const ChatTextInput = forwardRef(
  function ChatTextInput (
    props: ChatTextInputProps,
    ref: React.Ref<HTMLTextAreaElement>
  ) {
    const { value, onSubmit, onChange } = props

    const { t } = useTranslation()

    return (
      <textarea
        autoFocus
        ref={ref}
        className="resize-none grow px-6 py-2 text-gray-700 bg-transparent border-none focus:outline-hidden h-full"
        value={value}
        placeholder={t('chatInput:Ask to chat')}
        onChange={event => onChange?.(event.target.value)}
        rows={1}
        onKeyDown={event => {
          if (event.key === 'Enter' && !event.shiftKey && value.trim()) {
            event.preventDefault()
            onSubmit?.(event)
          }
        }}
      />
    )
  }
)
